export default __webpack_public_path__ + "static/media/custom_3_hole_angled_inlet.061e6484.jpg";